import BasePie from "../../sisu/chart/BasePie.sisu";

const NeoPie = BasePie

export default NeoPie;